/**
 * What a gesture shows while it lasts, in the board's layer: the rectangle a tool draws, the
 * line the pen draws (`#board-ink`), and the arrow being drawn from an item to the pointer.
 */
import { Show, type JSX } from "solid-js";
import { useApp } from "../../../app/context";
import { smoothPath, type Point, type Rect } from "../../../state/board";

/** The rectangle a drawing tool draws (`.board-drawing`). */
export function DrawPreview(props: { rect: Rect }): JSX.Element {
  const { board } = useApp();
  const r = () => props.rect;
  return <div class={`board-drawing tool-${board.tool()}`} style={{ left: `${Math.min(r().x, r().x + r().w)}px`, top: `${Math.min(r().y, r().y + r().h)}px`, width: `${Math.abs(r().w)}px`, height: `${Math.abs(r().h)}px` }} />;
}

/** The line the pen draws, with the pen's look. */
export function InkPreview(props: { points: Point[] }): JSX.Element {
  const { board } = useApp();
  return (
    <svg class="board-ink" width="1" height="1" aria-hidden="true">
      <path id="board-ink" d={smoothPath(props.points)} fill="none" stroke={board.pen().colour} stroke-width={board.pen().width} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

/** The arrow being drawn from item `from` to the point `to`. */
export function LinkPreview(props: { from: string; to: Point }): JSX.Element {
  const { board } = useApp();
  const from = () => board.content().places.get(props.from);
  return (
    <Show when={from()}>
      {(f) => (
        <svg class="board-arrows" aria-hidden="true">
          <line class="board-linking" x1={f().x + f().w / 2} y1={f().y + f().h / 2} x2={props.to.x} y2={props.to.y} />
        </svg>
      )}
    </Show>
  );
}
